module.exports = __webpack_public_path__ + "static/media/theme_vikinger.67fb5043.jpg";